import { create } from 'zustand'

type OnboardingFabStoreState = {
  isVisible: boolean
  setIsVisible: (visible: boolean) => void
}

const useOnboardingFabStore = create<OnboardingFabStoreState>(set => ({
  isVisible: false,
  setIsVisible: (visible: boolean) => set({ isVisible: visible }),
}))

export default useOnboardingFabStore

export const useOnboardingFabVisible = () => {
  const isVisible = useOnboardingFabStore(state => state.isVisible)
  const setIsVisible = useOnboardingFabStore(state => state.setIsVisible)

  return { isOnboardingFabVisible: isVisible, setOnboardingFabVisible: setIsVisible }
}
